import { localeFallbackChain } from '@mrigl/shared';
import { IntlMessageFormat } from 'intl-messageformat';
import { pseudoLocalize } from './pseudo.js';
import { aeb } from './catalogs/aeb.js';
import { ar } from './catalogs/ar.js';
import { en } from './catalogs/en.js';
import { fr } from './catalogs/fr.js';
export const CATALOGS = { ar, aeb, fr, en };
/**
 * Locale used for plural rules, numbers and dates. Tunisian Arabic has no CLDR data of its
 * own, so it formats like Arabic (Tunisia); Tunisian conventions use Latin digits.
 */
export const INTL_LOCALE = {
    ar: 'ar-TN',
    aeb: 'ar-TN',
    fr: 'fr-TN',
    en: 'en',
};
const compiled = new Map();
function formatter(locale, source, key) {
    const cacheKey = `${locale}|${source}|${key}`;
    let format = compiled.get(cacheKey);
    if (format === undefined) {
        format = new IntlMessageFormat(CATALOGS[source][key], INTL_LOCALE[locale]);
        compiled.set(cacheKey, format);
    }
    return format;
}
/**
 * Formats `key` for `locale`. Catalogs are complete (type-checked), but an empty message falls
 * back along the locale chain (aeb → ar → fr). Values are not escaped: callers rendering HTML
 * must escape the result.
 */
export function translate(locale, key, values = {}) {
    for (const source of localeFallbackChain(locale)) {
        if (CATALOGS[source][key].length > 0) {
            // Catalogs contain no rich-text tags, so formatting always yields a string.
            return formatter(locale, source, key).format(values);
        }
    }
    throw new Error(`no translation for ${key} in ${locale} or its fallbacks`);
}
export function createTranslator(locale) {
    return (key, values) => translate(locale, key, values);
}
const pseudoCompiled = new Map();
/**
 * Pseudo-localized message (French source, accented and expanded, wrapped in ⟦…⟧). Used by
 * test builds to prove that every visible string comes from the catalogs and that layouts
 * survive ~40% longer text.
 */
export function translatePseudo(key, values = {}) {
    let format = pseudoCompiled.get(key);
    if (format === undefined) {
        format = new IntlMessageFormat(pseudoLocalize(CATALOGS.fr[key]), INTL_LOCALE.fr);
        pseudoCompiled.set(key, format);
    }
    return format.format(values);
}
//# sourceMappingURL=translate.js.map